export default "__VITE_ASSET__$dsV36ce__"